/***
 * @Authors:
 *      Ashwin Rai (ashwinrai.com)
 *      Nikhil Chougule
 ***/

/*** Imports ***/

/* Library imports */
import React from "react";
import PropTypes from 'prop-types';

/* Style imports */
import './styles.css'
/*** End Imports ***/

const DataPanelLoadingView = (props) => {

    // helper function
    // event handlers for static component

    return (
        <div className = "animated-background"
             style={{height: 'fit-content',
                 flex : "1",
                 position : "relative",
                 minWidth : "400px",
                 marginRight : "0px",
                 overflow: 'hidden'
             }}
        >
            <div style={{paddingTop:'50px'}}>
                <div className="background-masker avl-hire-sect-top">
                    <div className="background-masker-fix-content"/>
                </div>
                <div className="background-masker title-avl-hire-sect-left">
                    <div className="background-masker-fix-content"/>
                </div>
                <div className="background-masker title-avl-hire-sect-right">
                    <div className="background-masker-fix-content"/>
                </div>
                <div className="background-masker title-avl-hire-sect-bottom">
                    <div className="background-masker-fix-content"/>
                </div>
                <div className="background-masker sub-content-avl-hire-sect-left">
                    <div className="background-masker-fix-content"/>
                </div>
                <div className="background-masker sub-content-avl-hire-sect-right">
                    <div className="background-masker-fix-content"/>
                </div>
                <div className="background-masker sub-content-avl-hire-sect-bottom">
                    <div className="background-masker-fix-content"/>
                </div>
            </div>
            <div style={{paddingTop:'72px'}}>
                <div className="background-masker avl-hire-sect-top">
                    <div className="background-masker-fix-content"/>
                </div>
                <div className="background-masker title-avl-hire-sect-left">
                    <div className="background-masker-fix-content"/>
                </div>
                <div className="background-masker title-avl-hire-sect-right">
                    <div className="background-masker-fix-content"/>
                </div>
                <div className="background-masker title-avl-hire-sect-bottom">
                    <div className="background-masker-fix-content"/>
                </div>
                <div className="background-masker sub-content-avl-hire-sect-left">
                    <div className="background-masker-fix-content"/>
                </div>
                <div className="background-masker sub-content-avl-hire-sect-right">
                    <div className="background-masker-fix-content"/>
                </div>
                <div className="background-masker sub-content-avl-hire-sect-bottom">
                    <div className="background-masker-fix-content"/>
                </div>
            </div>
            <div style={{paddingTop:'72px'}}>
                <div className="background-masker avl-hire-sect-top">
                    <div className="background-masker-fix-content"/>
                </div>
                <div className="background-masker title-avl-hire-sect-left">
                    <div className="background-masker-fix-content"/>
                </div>
                <div className="background-masker title-avl-hire-sect-right">
                    <div className="background-masker-fix-content"/>
                </div>
                <div className="background-masker title-avl-hire-sect-bottom">
                    <div className="background-masker-fix-content"/>
                </div>
                <div className="background-masker sub-content-avl-hire-sect-left">
                    <div className="background-masker-fix-content"/>
                </div>
                <div className="background-masker sub-content-avl-hire-sect-right">
                    <div className="background-masker-fix-content"/>
                </div>
                <div className="background-masker sub-content-avl-hire-sect-bottom">
                    <div className="background-masker-fix-content"/>
                </div>
            </div>
            <div style={{paddingTop:'72px'}}>
                <div className="background-masker avl-hire-sect-top">
                    <div className="background-masker-fix-content"/>
                </div>
                <div className="background-masker title-avl-hire-sect-left">
                    <div className="background-masker-fix-content"/>
                </div>
                <div className="background-masker title-avl-hire-sect-right">
                    <div className="background-masker-fix-content"/>
                </div>
                <div className="background-masker title-avl-hire-sect-bottom">
                    <div className="background-masker-fix-content"/>
                </div>
                <div className="background-masker sub-content-avl-hire-sect-left">
                    <div className="background-masker-fix-content"/>
                </div>
                <div className="background-masker sub-content-avl-hire-sect-right">
                    <div className="background-masker-fix-content"/>
                </div>
                <div className="background-masker sub-content-avl-hire-sect-bottom">
                    <div className="background-masker-fix-content"/>
                </div>
            </div>
            <div style={{paddingTop:'72px' , height: '100%'}}>
                <div className="background-masker avl-hire-sect-bottom">
                    <div className="background-masker-fix-content"/>
                </div>
            </div>
        </div>
    );
};

/**
 * all prop types which can be passed to this component
 */
DataPanelLoadingView.propTypes = {

};

/**
 * Only if default initialization is required
 * Default props value for this component
 */
DataPanelLoadingView.defaultProps ={

};

export default DataPanelLoadingView;


// WEBPACK FOOTER //
// ./src/components/LoadingViews/DataPanelLoadingView.js